import React from "react"

export default function Counter() {
  return (
    <symbol id="svg-select-counter" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M28.5,15.6h-4.1c-0.1-3.3-2.8-5.9-6.1-5.9h-0.8c1.4-0.6,2.4-2,2.4-3.6c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,1.6,1,3,2.4,3.6h-0.8  c-3.3,0-6,2.6-6.1,5.9H3.3c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h0.3v11.4H28V18.5h0.3c0.8,0,1.4-0.6,1.4-1.4  C29.9,16.3,29.3,15.6,28.5,15.6z M16,8.9c-1.5,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8S17.6,8.9,16,8.9z M5,18.5h22v10.2  H5V18.5z M3.6,17.3c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h24.9c0.1,0,0.3,0.1,0.3,0.3s-0.1,0.3-0.3,0.3H3.6z M8.8,15.6  c0.1-2.6,2.2-4.7,4.9-4.7h4.6c2.6,0,4.8,2.1,4.9,4.7H8.8z"
      />
    </symbol>
  )
}
